export default __webpack_public_path__ + "static/media/Stacked.97e11902.ico";